/* Empty-result recovery for Globo. Native collection engines own their recovery UI. */
(function (factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') api.init();
})(function () {
  'use strict';
  const isFacet = key => /^gf_\d+$/.test(key);
  function selections(input) {
    const url = new URL(input);
    return Array.from(url.searchParams).filter(([key]) => isFacet(key))
      .flatMap(([key, value]) => value.split(',').filter(Boolean).map(value => ({ key, value })));
  }
  function removeSelection(input, key, value) {
    const url = new URL(input);
    const remaining = url.searchParams.getAll(key).flatMap(item => item.split(',')).filter(item => item !== value);
    url.searchParams.delete(key);
    if (remaining.length) url.searchParams.set(key, remaining.join(','));
    url.searchParams.delete('page');
    return url.href;
  }
  function init() {
    if (!document.body.matches('.template-collection') || document.querySelector('volantes-collection, tapas-native-pilot')) return;
    const container = document.querySelector('#ProductGridContainer');
    if (!container || container.dataset.emptyRecoveryInitialized) return;
    container.dataset.emptyRecoveryInitialized = 'true';
    const english = document.documentElement.lang.startsWith('en');
    const labels = english
      ? { gf_562474: 'Brand', gf_562475: 'Category', gf_562476: 'Type of use', gf_562477: 'Automobiles', gf_562479: 'Line' }
      : { gf_517485: 'Marca', gf_518125: 'Categoría', gf_517490: 'Aplicación', gf_517537: 'Automóviles', gf_517538: 'Motores', gf_517524: 'Línea' };
    let frame = 0;
    let signature = '';
    function sync() {
      frame = 0;
      const grid = container.querySelector('#gf-products');
      const existing = container.querySelector('[data-cf-empty-recovery]');
      const selected = selections(location.href);
      const emptyNode = grid && Array.from(grid.children).find(node => !node.hasAttribute('data-cf-empty-recovery') && /no hay productos|no se encontraron productos|no products|no results|no matches/i.test(node.textContent));
      if (!grid || grid.querySelector('.spf-product-card-wrapper') || !emptyNode || !selected.length) {
        if (existing) existing.remove();
        signature = '';
        return;
      }
      const nextSignature = location.href;
      if (existing && signature === nextSignature) return;
      if (existing) existing.remove();
      signature = nextSignature;
      const panel = document.createElement(grid.matches('ul, ol') ? 'li' : 'div');
      panel.className = 'cf-empty-recovery';
      panel.dataset.cfEmptyRecovery = '';
      const hint = document.createElement('p');
      hint.textContent = english ? 'Remove one filter to broaden your results. Your other filters and sorting will stay selected.' : 'Quitá un filtro para ampliar los resultados. Conservamos los demás y el orden elegido.';
      panel.append(hint);
      const group = document.createElement('div');
      group.className = 'cf-empty-recovery__selections';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', english ? 'Remove an active filter' : 'Quitar un filtro activo');
      selected.forEach(({ key, value }) => {
        const link = document.createElement('a');
        link.href = removeSelection(location.href, key, value);
        const label = labels[key] || (english ? 'Filter' : 'Filtro');
        const detail = /^\d+$/.test(value) ? '' : ': ' + value;
        link.textContent = (english ? 'Remove ' : 'Quitar ') + label + detail + ' ×';
        group.append(link);
      });
      panel.append(group);
      const opener = document.querySelector('.gf-refine-toggle-mobile button');
      if (opener) {
        const review = document.createElement('button');
        review.type = 'button';
        review.dataset.cfReviewGlobo = '';
        review.textContent = english ? 'Review filters' : 'Revisar filtros';
        review.addEventListener('click', () => document.querySelector('.gf-refine-toggle-mobile button')?.click());
        panel.append(review);
      }
      grid.append(panel);
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, subtree: true, characterData: true });
    document.addEventListener('globoFilterRenderCompleted', schedule);
    window.addEventListener('popstate', schedule);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      cancelAnimationFrame(frame);
      document.removeEventListener('globoFilterRenderCompleted', schedule);
      window.removeEventListener('popstate', schedule);
      document.removeEventListener('shopify:section:unload', unload);
      delete container.dataset.emptyRecoveryInitialized;
    };
    document.addEventListener('shopify:section:unload', unload);
    schedule();
  }
  if (typeof document !== 'undefined') document.addEventListener('shopify:section:load', init);
  return { selections, removeSelection, init };
});
